import { render, staticRenderFns } from "./lost-password.vue?vue&type=template&id=45b32572"
import script from "./lost-password.vue?vue&type=script&lang=ts"
export * from "./lost-password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports